import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import RecordsPage from "./pages/RecordsPage";
import ProfilePage from "./pages/ProfilePage";
import UploadPage from "./pages/UploadPage";
import { ProfileProvider } from "./context/ProfileContext";
import UsersPage from "./pages/UsersPage";
import EditUserPage from "./pages/EditUserPage";
import LogoutPage from "./pages/LogoutPage";
import { CacheProvider } from "./context/CacheContext";
import PowerPage from "./pages/PowerPage";
import TariffsPage from "./pages/TariffsPage";
import DebtsPage from "./pages/DebtsPage";
import MembershipPage from "./pages/MembershipPage";
import BillsPage from "./pages/BillsPage";
import HelpPage from "./pages/HelpPage";
import ErrorBoundary from "./pages/ErrorBoundary";
import TargetPage from "./pages/TargetPage";
import MessagesPage from "./pages/MessagesPage";
import RequisitePage from "./pages/RequisitePage";
import ManageHelpPage from "./pages/ManageHelpPage";
import ManageMessagesPage from "./pages/ManageMessagesPage";
import ManageRequisitePage from "./pages/ManageRequisitePage";
import ManageTelegramPage from "./pages/ManageTelegramPage";
import TelegramPage from "./pages/TelegramPage";

function App() {

  let token = "";
  try {
    token = localStorage.getItem("token") || "";
  } catch (e) {
    console.error("Error reading token from localStorage:", e);
  }
  let page = "/message";
  try {
    page = localStorage.getItem("page") || "/message";
  } catch (e) {
    console.error("Error reading page from localStorage:", e);
  }

  return (
    <ErrorBoundary name={"App"}>
      <CacheProvider>
        <ProfileProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Navigate to={(token ? page : "/login") + window.location.search} replace/>}/>
              <Route path="/login" element={<LoginPage/>}/>
              <Route path="/logout" element={<LogoutPage/>}/>
              <Route path="/profile" element={<ProfilePage/>}/>
              <Route path="/tariffs" element={<TariffsPage/>}/>
              <Route path="/bills" element={<BillsPage/>}/>
              <Route path="/power" element={<PowerPage/>}/>
              <Route path="/debts" element={<DebtsPage/>}/>
              <Route path="/membership" element={<MembershipPage/>}/>
              <Route path="/target" element={<TargetPage/>}/>
              <Route path="/records" element={<RecordsPage/>}/>
              <Route path="/users" element={<UsersPage/>}/>
              <Route path="/user/:account" element={<EditUserPage/>}/>
              <Route path="/upload" element={<UploadPage/>}/>
              <Route path="/help" element={<HelpPage/>}/>
              <Route path="/message" element={<MessagesPage/>}/>
              <Route path="/requisite" element={<RequisitePage/>}/>
              <Route path="/telegram" element={<TelegramPage/>}/>
              <Route path="/manage/message" element={<ManageMessagesPage/>}/>
              <Route path="/manage/requisite" element={<ManageRequisitePage/>}/>
              <Route path="/manage/help" element={<ManageHelpPage/>}/>
              <Route path="/manage/telegram" element={<ManageTelegramPage/>}/>
            </Routes>
          </Router>
        </ProfileProvider>
      </CacheProvider>
    </ErrorBoundary>
  );
}

export default App;
